module.exports = __webpack_public_path__ + "img/tiktok.9aea52f0.svg";